import * as React from 'react';
import { CopyTextWrapper } from './Copy_SC';
import { SnackBar, XIIcon } from '@inmoment/the-kitchen';

type SnackBarProps = Parameters<typeof SnackBar>[0];

export interface Props {
  children?: React.ReactNode;
  hasIcon?: boolean;
  textToCopy?: string;
}

export const Copy: React.FC<Props> = (props) => {
  const refEl = React.useRef<HTMLDivElement>(null);
  const textArea = React.useRef<HTMLTextAreaElement>(null);
  const { children, textToCopy, hasIcon = true } = props;
  const [snackBarObject, setSnackBarObject] = React.useState<SnackBarProps | null>(null);

  const refText = refEl.current ? refEl.current.innerText : '';

  function handleClick() {
    textArea.current?.select();
    document.execCommand('copy');
    setSnackBarObject({
      mode: 'default',
      text: `${textToCopy || refText} copied to clipboard`,
      dismissTime: 5000,
      autoDismiss: true,
      id: new Date().getTime().toString(),
    });
  }

  return (
    <>
      <SnackBar {...snackBarObject} />
      <CopyTextWrapper onClick={handleClick} ref={refEl}>
        {hasIcon ? <XIIcon icon="copy" style={{ float: 'right' }} /> : null}
        {children}
      </CopyTextWrapper>
      <textarea style={{ position: 'fixed', top: 0, opacity: 0 }} value={textToCopy || refText} ref={textArea} readOnly />
    </>
  );
};
